import { render } from "./noticDetails.vue?vue&type=template&id=5fba9a12"
import script from "./noticDetails.vue?vue&type=script&lang=js"
export * from "./noticDetails.vue?vue&type=script&lang=js"

import "./noticDetails.vue?vue&type=style&index=0&id=5fba9a12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__